<template>
	<div class="hiq-digital-resources__types hiq-search-filter__types">
    <label class="hiq-digital-resources__types-label" for="types">
      <strong>Filtrera på funktion</strong>    
      <span> {{ filterText }} </span>
    </label>
    <div
      class="hiq-digital-resources__types-options hiq-search-filter__types-options"
      id="types">
      <div
        class="hiq-digital-resources__types-option hiq-search-filter__types-option"
        v-for="(type, index) in filters"
        :key="index">
        <label
          :for="type.name"
          :class="type.selected ? 'checked' : ''"
          class="hiq-digital-resources__types-option__label
            hiq-search-filter__types-option-label">
          <input
            class="hiq-digital-resources__types-option__checkbox
              hiq-search-filter__types-option-checkbox"
            type="checkbox"
            :id="type.name"
            v-model="type.selected"
            @change="onSelectFilter()"
          />
          <span class="hiq-digital-resources__types-option__text
            hiq-search-filter__types-option-text">
            {{ type.title }}
          </span>
          <span class="hiq-digital-resources__types-option__deselect
            hiq-search-filter__types-option-deselect"
            v-if="type.selected">
            <span class="show-for-sr">, ta bort filter</span>
          </span>
        </label>
      </div>
    </div>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';
import { search } from '../store/actions';
import { IFilter } from '../store/state';

interface IArticleTypesMethods {
  onSelectFilter(): void;
}

interface IArticleTypesComputed {
	filters: IFilter[];
  filterText: string;
}

export default Vue.extend<{}, IArticleTypesMethods, IArticleTypesComputed, {}>({
	name: 'ArticleTypes',
	methods: {
		onSelectFilter() {
			this.$store.commit({
        type: 'setSelectedTags',
        payload: this.filters
          .filter((f: IFilter) => f.selected)
          .map((f: IFilter) => f.name)
          .join(',')
      })
      this.$store.dispatch(search(''));
		}
	},
	computed: {
    filterText() {
      return this.$store.getters.filterText;
    },
		filters() {
			return this.$store.getters.filters;
		}
	},
	components: {
	}
})
</script>
